module.exports = __webpack_public_path__ + "static/img/information_no_data.d3ab6f8c.svg";